import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';

import Footer from './Components/Footer.jsx';
import Header from './Components/Header.jsx';
import "./Assets/Styles/style.scss"
// Lazy load pages for better performance
const Home = lazy(() => import('./Pages/Home.jsx'));
const Products = lazy(() => import('./Pages/Products.jsx'));
const Gallery = lazy(() => import('./Pages/Gallery.jsx'));
const AboutUs = lazy(() => import('./Pages/AboutUs.jsx'));
const Contact = lazy(() => import('./Pages/Contact.jsx'));
const AdminLogin = lazy(() => import('./Pages/Admin/AdminLogin.jsx'));
const AdminRegister = lazy(() => import('./Pages/Admin/AdminRegister.jsx'));
const AdminDashboard = lazy(() => import('./Pages/Admin/AdminDashboard.jsx'));
const DashboardHome = lazy(() => import('./Components/Admin/DashboardHome.jsx'));
const ProductsTable = lazy(() => import('./Components/Admin/ProductsTable.jsx'));
const EnquiryTable = lazy(() => import('./Components/Admin/EnquiryTable.jsx'));
const NotFound = lazy(() => import('./Pages/NotFound.jsx'));


// Loading component
const PageLoader = () => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#477238', gap: '15px' }}>
    <div className="loader" style={{
      width: '50px',
      height: '50px',
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #477238',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }}></div>
    <div style={{ fontFamily: 'Segoe UI, sans-serif', fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase' }}>Dhapu Farms</div>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </>
);

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<DashboardHome />} />
            <Route path="products" element={<ProductsTable />} />
            <Route path="enquiries" element={<EnquiryTable />} />
          </Route>

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}